import HCaptcha from '@hcaptcha/react-hcaptcha';
export default HCaptcha;
